(function($) {
    var __ = {

        vue : "",

        // Toggle the menu class
        configureQuiz: function() {

            // product filter
            __.vue = new Vue({//
                // vue container
                delimiters: ['${', '}$'],
                el: '#v-quiz',
                // Vue data fields
                data: {
                    score: 0,
                    current_question: 0,
                    current_choice: '',
                    question_value: 0,
                    show_results: false,
                    questions: LOCALIZED.questions,
                    results: LOCALIZED.results
                },
                created: function () {
                    // On Creation
                },
                // vue methods //
                methods: {
                    updateSelection: function (choice) {
                        if(this.current_choice === choice){
                            this.current_choice = "";
                        }else{
                            this.current_choice = choice;
                        }
                    },
                    submitAnswer: function () {

                        // dont submit if another submission is in progress
                        if( ! $('.j-quiz').hasClass('pg-quiz--answer-mode') ){
                            // Show the answers for this question
                            this.answerResults();
                            // Show the next question in 1.5 seconds
                            setTimeout( this.nextQuestion, 1000 );
                        }
                    },
                    answerResults: function (){
                        $('.j-quiz').addClass('pg-quiz--answer-mode');
                        
                        if(this.current_choice.answer){
                            this.question_value = this.questions[this.current_question].value;
                            // Wait for a second to add the score to match animation
                            setTimeout(function(){
                                __.vue.score += __.vue.questions[__.vue.current_question].value;
                            }, 1000);
                        }else{
                            this.question_value = 0;
                        }
                        
                    },
                    nextQuestion: function() {
                        $('.j-quiz').removeClass('pg-quiz--answer-mode');
                        if( this.current_question < this.questions.length - 1 ){
                            this.current_question++;
                        }else{
                           this.show_results = true;
                        }
                    }, 
                    getResults: function(){
                        var results = "";
                        $.each(this.results, function(i){
                            var result = __.vue.results[i];
                            if (this.min_value <= __.vue.score){
                                results = this.result;
                            }
                        });
                        results = results.replace('{SCORE}', __.vue.score);
                        return results;
                    },
                },
            });
        },
        // Function to call to setup functionality
        setup: function() {
            __.configureQuiz();
        },
    };
    // Attach Toolbox to window //
    window._quiz = __;
})(jQuery); // Fully reference jQuery after this point.